type Item = {
  value: number,
  symbol: string,
};

const list: Item[] = [
  { value: 1e18, symbol: "E" },
  { value: 1e15, symbol: "P" },
  { value: 1e12, symbol: "T" },
  { value: 1e9, symbol: "G" },
  { value: 1e6, symbol: "M" },
  { value: 1e3, symbol: "k" },
];

const lastItem: Item = { value: 1, symbol: "" };

const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;

export const nFormatter = (num: number, digits: number) => {
  const { value, symbol } = list.find(({ value }) =>  (num >= value)) || lastItem;

  return `${(num / value).toFixed(digits).replace(rx, "$1")} ${symbol}`;
};
